<template>
    <v-dialog
            v-model="dialog"
            max-width="500"
    >
        <v-card>
            <v-card-title class="headline">Select new folder</v-card-title>

            <v-card-text>
                <v-treeview class="p-4"
                            v-if="documents.length > 0"
                            :items="documents"
                            open-all
                            v-model="tree"
                            activatable
                            @update:active="select($event)"
                            return-object
                >
                    <template slot="prepend" slot-scope="{ item, open, leaf }">
                        <v-icon v-if="!item.file">
                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                        <v-icon v-else>
                            {{ files[item.file] }}
                        </v-icon>
                    </template>
                    <template slot="label" slot-scope="{ item, open, leaf }">
                            {{ item.name }}
                    </template>
                </v-treeview>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="green darken-1"
                        flat="flat"
                        @click="close()"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['documents', 'dialog', 'model'],
        data () {
            return {
                tree: [],
                files: {
                    html: 'mdi-language-html5',
                    js: 'mdi-nodejs',
                    json: 'mdi-json',
                    md: 'mdi-markdown',
                    pdf: 'mdi-file-pdf',
                    png: 'mdi-file-image',
                    txt: 'mdi-file-document-outline',
                    xls: 'mdi-file-excel'
                },
            }
        },
        methods: {
            select (payload) {
                if (payload[0]) {
                    this.$store.dispatch('moveDocument', {
                        id: this.dialog,
                        folder_id: payload[0].id,
                        model: this.model
                    }).then((res) => {
                        this.$emit('editado');
                    }).catch((error) => {

                    });
                }
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/components/MoveDocumentComponent.vue